var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-layout-background",class:[{ 'px-12': _vm.$vuetify.breakpoint.mdAndUp },{'afterLogin':_vm.isLoggedIn}]},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }